/**
 * ProviderDistribution 组件
 *
 * 使用饼图/柱状图显示各供应商的使用分布。
 */

import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import type { SearchProviderStats } from '../../../services/searchAdminApi';

interface ProviderDistributionProps {
  providers: SearchProviderStats[];
  loading: boolean;
}

const PROVIDER_COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#8b5cf6', '#ec4899'];

export const ProviderDistribution: React.FC<ProviderDistributionProps> = ({
  providers,
  loading,
}) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <div className="h-48 animate-pulse bg-gray-100 rounded" />
      </div>
    );
  }

  if (providers.length === 0) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-6 text-center text-gray-500">
        暂无供应商统计
      </div>
    );
  }

  const chartData = providers.map((p, idx) => ({
    name: p.display_name || p.provider_name,
    checks: p.total_checks,
    failures: p.total_failures,
    keys: p.key_count,
    fill: PROVIDER_COLORS[idx % PROVIDER_COLORS.length],
  }));

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <h3 className="text-sm font-medium text-gray-600 mb-4">
        供应商使用分布
      </h3>
      <div className="h-48">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData} layout="vertical">
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis type="number" tick={{ fontSize: 10 }} stroke="#9ca3af" />
            <YAxis
              dataKey="name"
              type="category"
              tick={{ fontSize: 11 }}
              stroke="#9ca3af"
              width={80}
            />
            <Tooltip contentStyle={{ fontSize: 12, borderRadius: 4 }} />
            <Bar dataKey="checks" name="检查次数" radius={[0, 2, 2, 0]}>
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.fill} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ProviderDistribution;
